/**
 * Length of German ZipCode.
 */
export const ZIP_CODE_LENGTH = 5;

/**
 * Length of BIC or SWIFT code.
 */
export const BIC_OR_SWIFT_CODE_LENGTH = 20;

/**
 * Mask for German ZipCode input.
 * E.g. 00000
 */
export const zipCodeInputMask = Array(ZIP_CODE_LENGTH).fill(/\d/);

/**
 * Mask for BIC or SWIFT input.
 * E.g. OSDDDE81XX
 */
export const bicOrSwiftMask = Array(BIC_OR_SWIFT_CODE_LENGTH).fill(/[A-Z-0-9]/i);
